import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  AUTH_CHECK_TOKEN,
  AUTH_SIGNIN,
  AUTH_SIGNOUT,
  AUTH_PROFILE_FETCH,
  SIGNIN_CONSENT_UPDATE,
  SIGNIN_PASSWORD_UPDATE,
  MEMBER_PROFILE_UPDATE,
  MEMBER_PROFILE_CHANGE_PASSWORD,
  PDPA_REQUEST
} from "../actions/types";
import {
  authSignOutSuccess,
  authProfileFetchSuccess,
  authClosePopup,
  signinOpenConsent ,
  popupOpenTierShow ,
  signinCloseConsent,
  signOpenChangeDefaultPassword,
  authSignInSuccess,
  memberProfileFetch,
  sendAgrementPDPASuccess
} from "../actions";
import {
  authorizationHeader,
  getErrorMessage_v2,
  // getToken,
} from "../utils/apiUtil";
import axios from "axios";
import axiosRetry from "axios-retry";
import {
  showErrorMessage,
  authFetchResponse,
  signinOpenNotFound,
  showSuccessMessage
} from "../actions";

axiosRetry(axios, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
});

const RGB_HEX = /^#?(?:([\da-f]{3})[\da-f]?|([\da-f]{6})(?:[\da-f]{2})?)$/i;
const hex2RGB = (str, a) => {
  const [ , short, long ] = String(str).match(RGB_HEX) || [];

  if (long) {
    const value = Number.parseInt(long, 16);
    return 'rgb(' + String(value >> 16) + ', ' + String(value >> 8 & 0xFF) + ', ' + String( value & 0xFF)+ ', ' + a +  ')';
  
  } 
};

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
// API


const authenAccesstoken = async (payload) => {
  const res = await axios.post(
    `${REACT_APP_API_URL}/v1/acare/auth/access-token`,
    {
      client_id: "2AD5G", /// 93E8524F77E2EA61FFA9713258DD4042
      channel_secret: "f8808d2cf2fafb44212c26696a35c12f", /// f21c53a69662c21244bfaf2fc2d8088f
    }
  );

  localStorage.setItem(
    "member",
    JSON.stringify({
      token: res.data.access_token,
      tokenType: res.data.token_type,
    })
  );
};

const validateTokenRequest = async (payload) => {
  const inputData = {
    gigya_uid: payload.gigya_uid,
    user_signup_token: payload.user_signup_token,
  };
  return payload
  // return await axios
  //   .post(`${REACT_APP_API_URL}/v1/acare/user/login`, inputData, {
  //     headers: authorizationHeader("Bearer"),
  //   })
  //   .then((response) => response.data)
  //   .catch((error) => {
  //     throw error;
  //   });
};

const authSignInRequest = async ({ username, password, page_lang }) => {
  const inputData = {
    // email: email,
    password: password,
    // page_lang: page_lang,
    member_code : username
  };
  return await axios
    .post(`${REACT_APP_API_URL}/client/v1/auth/login`, inputData, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// const authSignOutRequest = async () => {
//   await axios
//     .post(
//       `${REACT_APP_API_URL}/v1/member/logout`,
//       {
//         token: getToken(),
//       },
//       {
//         headers: authorizationHeader("Bearer"),
//       }
//     )
//     .then((response) => response.data)
//     .catch((error) => {
//       throw error;
//     });
// };

const authProfileFetchRequest = async () => {
  return await axios
    .get(`${REACT_APP_API_URL}/client/v1/my/profile`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// const updateDefaultPasswordRequest = async (payload) => {
//   return await axios
//     .put(`${REACT_APP_API_URL}/client/v1/my/changeDefaultPassword`, payload ,{
//       headers: authorizationHeader("Bearer"),
//     })
//     .then((response) => response.data)
//     .catch((error) => {
//       throw error;
//     });
// };


const updateConsentRequest = async (payload) => {
  return await axios
    .put(`${REACT_APP_API_URL}/client/v1/consent/update`, payload ,{
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const updatlogConsentRequest = async (payload) => {
  return await axios
    .put(`${REACT_APP_API_URL}/client/v1/my/consent/update`, payload ,{
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const profileUpdateRequest = async (payload) => {
	return await axios
		.put(`${REACT_APP_API_URL}/v1/member/profile`, payload, {
			headers: authorizationHeader("Bearer")
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

const profileChangePassowrdRequest = async (payload) => {
	return await axios
		.put(`${REACT_APP_API_URL}/v1/member/changePassword`, payload, {
			headers: authorizationHeader("Bearer")
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

const pdpaSendAgreementRequest = async (payload) => {
  return await axios
		.post(`${REACT_APP_API_URL}/client/v1/pdpa`, {
      token:payload.id,
      action:payload.agreement
    }, {
      headers: authorizationHeader("Bearer")
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

// WORKER
function* authSignIn({ payload }) {
  try {
    const data = yield call(authSignInRequest, payload);
    if (data) {      

      // document.body.style.setProperty('--default', data.memberLevelTheme.primary_color);
      // document.body.style.setProperty('--g1',  hex2RGB(data.memberLevelTheme.primary_color , 0.5) );
      // document.body.style.setProperty('--g2',  hex2RGB(data.memberLevelTheme.primary_color , 0.5) );
      // document.body.style.setProperty('--secondary', data.memberLevelTheme.secondary_color);
      // document.body.style.setProperty('--secondary', data.memberLevelTheme.secondary_color);
      // document.body.style.setProperty('--gradient', data.memberLevelTheme.gradient);
      
      localStorage.setItem(
        "member",
        JSON.stringify({
          token: data.accessToken,
          refreshToken: data.refreshToken,
          consent_status : data.consent_status,
          is_change_password_default : data.is_change_password_default ,
          success: true,
          color:  data.memberLevelTheme,
        })
      );

      try {
        try {
          yield call(updateConsentRequest, { version : Number(process.env.REACT_APP_TMBAM_CONSENT_V || 2)});  // update Consent
        } catch (error) {
        }
      } catch (error) {
        console.log(error);
      }

      // if(data.consent_status === "disable"){
      //   yield put(signinOpenConsent(data));
      //   return ;
      // }
      // if(data.is_change_password_default === "false"){
      //   yield put(signOpenChangeDefaultPassword());
      //   return ;
      // }
      let _localStorageMember = localStorage.getItem("member");
      let _member = JSON.parse(_localStorageMember);
      yield put(authSignInSuccess(_member));

      yield put(authClosePopup());

      const data2 = yield call(authProfileFetchRequest, {});
      yield put(authProfileFetchSuccess(data2));
      // if(data.consent_status === "enable" && data.is_change_password_default === "true" ){
      if(data.consent_status === "enable" ){
        yield put(popupOpenTierShow());
      }

    } else {
      yield put(signinOpenNotFound("Sign in Error : Member not Found"));
      throw new Error(data.msg);
    }
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      if(getErrorMessage_v2(error.response) === 'Privilege code not found'){
        yield put(showErrorMessage('fail.auth'));
      }else{
        yield put(showErrorMessage(getErrorMessage_v2(error.response)));
      }
    }
  }
}

function* authSignOut() {
  try {
    // yield call(authSignOutRequest);
    localStorage.removeItem("member");
  
    document.location = "/";
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

function* authProfileFetch({ payload }) {
  try {
    const data = yield call(authProfileFetchRequest, payload);
    yield put(authProfileFetchSuccess(data));
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

function* validateToken({ payload }) {
  try {
    // yield call(authenAccesstoken, payload);
    const data = yield call(validateTokenRequest, payload);
    if (data.errorStatus === "Ready to Login") {
      yield put(authFetchResponse(data));
      localStorage.setItem(
        "member",
        JSON.stringify({
          token: data.new_token,
          success: true,
        })
      );
      document.location = "/#/";
    } else {
      yield put(authFetchResponse(data));
    }
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authFetchResponse(error.response.data));
    } else if (
      error.response &&
      error.response.status &&
      error.response.status === 400
    ) {
      yield put(authFetchResponse(error.response.data));
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

function* updateDefaultPassword({ payload }) {
  // try {

  //   const data = yield call(updateDefaultPasswordRequest, payload);  // update Consent
  //   if(data && data.success){
  //     let localStorageMember = localStorage.getItem("member");
  //     let member = JSON.parse(localStorageMember);
  //     localStorage.removeItem("member");
  //     localStorage.setItem("member", JSON.stringify({
  //       token: member.token,
  //       refreshToken: member.refreshToken,
  //       consent_status : member.consent_status,
  //       is_change_password_default : "true",
  //       success: true,
  //       color:  member.memberLevelTheme,
  //     }));
  //     let _localStorageMember = localStorage.getItem("member");
  //     let _member = JSON.parse(_localStorageMember);
  //     yield put(authSignInSuccess(_member));
  //     const _data = yield call(authProfileFetchRequest, {});
  //     yield put(authProfileFetchSuccess(_data));
  //     yield put(popupOpenTierShow());
  //     document.location = "/#/";
  //   }
  // } catch (error) {
  //   if (
  //     error.response &&
  //     error.response.status &&
  //     error.response.status === 401
  //   ) {
  //     localStorage.removeItem("member");
  //     yield put(authSignOutSuccess());
  //   } else {
  //     if(getErrorMessage_v2(error.response) === 'Member Not found!'){
  //       yield put(showErrorMessage('fail.member-not-found'));
  //     }else if(getErrorMessage_v2(error.response) === 'Password not Match!!'){
  //       yield put(showErrorMessage('fail.password-not-match'));
  //     }else{
  //       yield put(showErrorMessage(getErrorMessage_v2(error.response)));
  //     }
  //   }
  // }
}

function* updateConsent({ payload }) {
  try {
    const data = yield call(updateConsentRequest, payload);  // update Consent
    if(data && data.version){
      let localStorageMember = localStorage.getItem("member");
      let member = JSON.parse(localStorageMember);
      localStorage.removeItem("member");
      localStorage.setItem("member", JSON.stringify({
        token: member.token,
        refreshToken: member.refreshToken,
        consent_status : "enable",
        is_change_password_default : member.is_change_password_default ,
        success: true,
        color:  member.memberLevelTheme,
      }));
      let _localStorageMember = localStorage.getItem("member");
      let _member = JSON.parse(_localStorageMember);
      yield put(authSignInSuccess(_member));
      const _data = yield call(authProfileFetchRequest, {});
      yield put(authProfileFetchSuccess(_data));
      yield put(signinCloseConsent());
      yield put(popupOpenTierShow());
      document.location = "/#/";
    }
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

function* profileUpdate({ payload }) {
	try {
		yield call(profileUpdateRequest, payload);
		const data = yield call(authProfileFetchRequest, payload);
		yield put(authProfileFetchSuccess(data));
	} catch (error) {
		if(error.response && error.response.status && error.response.status === 401){
			localStorage.removeItem("member");
		}else{
			yield put(showErrorMessage(getErrorMessage_v2(error.response)));
		}
	}
}

function* profileChangePassowrd(payload) {
	try {
		const data = yield call(profileChangePassowrdRequest, payload.payload);
		if(data.success==='true'){
			payload.closeModal();
			yield put(showSuccessMessage("Password Has been Change!"));
		}else{
			yield put(showErrorMessage(data.message));
		}
	} catch (error) {
		if(error.response && error.response.status && error.response.status === 401){
			localStorage.removeItem("member");
		}else{
			yield put(showErrorMessage(getErrorMessage_v2(error.response)));
		}
	}
}

function* pdpaSendAgreement(payload) {
	try {
		const data = yield call(pdpaSendAgreementRequest, payload.payload);
		if(data){
      localStorage.setItem("pdpa-agement",JSON.stringify(data));
      yield put(sendAgrementPDPASuccess(data));
		}
	} catch (error) {
		console.log(error);
	}
}



// WATCHER
export function* validateTokenWatcher() {
  yield takeEvery(AUTH_CHECK_TOKEN, validateToken);
}

export function* signInWatcher() {
  yield takeEvery(AUTH_SIGNIN, authSignIn);
}

export function* signOutWatcher() {
  yield takeEvery(AUTH_SIGNOUT, authSignOut);
}

export function* authProfileFetchWatcher() {
  yield takeEvery(AUTH_PROFILE_FETCH, authProfileFetch);
}

export function* updateConsentdWatcher() {
  yield takeEvery(SIGNIN_CONSENT_UPDATE, updateConsent);
}
export function* updateDefaultPasswordWatcher() {
  yield takeEvery(SIGNIN_PASSWORD_UPDATE, updateDefaultPassword);
}

export function* profileUpdateWatcher() {
	yield takeEvery(MEMBER_PROFILE_UPDATE, profileUpdate);
}

export function* profileChangePassowrdWatcher() {
	yield takeEvery(MEMBER_PROFILE_CHANGE_PASSWORD, profileChangePassowrd);
}

export function* pdpaSendAgreementWatcher() {
	yield takeEvery(PDPA_REQUEST, pdpaSendAgreement);
}



export default function* rootSaga() {
  yield all([
    fork(validateTokenWatcher),
    fork(signInWatcher),
    fork(signOutWatcher),
    fork(authProfileFetchWatcher),
    fork(updateConsentdWatcher),
    fork(updateDefaultPasswordWatcher),
    fork(profileUpdateWatcher),
    fork(profileChangePassowrdWatcher),
    fork(pdpaSendAgreementWatcher),
  ]);
}
